// Boshliq (2026-09-05): headerda foydalanish muddati «batareyka» (magazin / kontragent tizimlari, tenant > 1).
// Muddat tugagan sari kamayadi, rang yashil → sariq → qizil; 7 kun qolganda qizil + sekin yonib-o'chadi; 3 kun — tez; 1 kun — «×».
// Bu faqat ACCOUNT muddati uchun (AI tokenlari emas). Manba: login / MyPermissions javobidagi `subscription {until, from, daysLeft, showBattery}`.
// Boshliq (2026-09-05, 04:15): «58 дн» matni batareykaning ICHIDA — tashqaridagi yozuv telefonda 2 qatorga bo'linib xunuk chiqdi.
import React, { lazy, Suspense, useContext, useState } from "react"
import { Tooltip } from "antd"
import moment from "moment"
import { AuthContext } from "../contexts/auth/AuthContext"
import i18n from "../services/i18n"

const tf = (k: string, d: string) => (i18n.exists(k) ? String(i18n.t(k)) : d)
// tog'a #3975: abonent rejimida batareyka bosiladi — hamkor admini o'z abonent kartasini ko'radi (alohida chunk)
const AbonentMineModal = lazy(() => import("./abonent/Abonent").then((m) => ({ default: m.AbonentMineModal })))

export default function SubscriptionBattery({ compact }: { compact?: boolean }) {
  const { authState } = useContext(AuthContext)
  const [open, setOpen] = useState(false)
  const u: any = authState?.user
  const sub = u?.subscription
  if (!u || Number(u.tenantId || 1) <= 1 || !sub?.until) return null
  if (sub.showBattery === false) return null   // Boshliq (2026-09-05): sozlamada o'chirilgan (default yoqilgan)
  const until = moment(sub.until)
  const daysLeft = Math.max(0, Number(sub.daysLeft ?? until.diff(moment(), "days", true)))
  const from = sub.from ? moment(sub.from) : null
  const totalDays = from && until.isAfter(from) ? Math.max(1, until.diff(from, "days", true)) : 30   // davr boshi noma'lum bo'lsa 30 kunlik shkala
  const pct = Math.max(0, Math.min(100, (daysLeft / totalDays) * 100))
  const expired = daysLeft <= 0
  // rang: >50% yashil, 20–50% sariq, <20% yoki ≤7 kun qizil
  const color = expired || daysLeft <= 7 || pct < 20 ? "#dc2626" : pct < 50 ? "#f59e0b" : "#16a34a"
  const blink = expired ? "sub-blink-fast" : daysLeft <= 3 ? "sub-blink-fast" : daysLeft <= 7 ? "sub-blink-slow" : ""
  const lastDay = daysLeft <= 1
  const days = Math.ceil(daysLeft)
  const dayLbl = tf("daysShort", "kun")
  const label = expired ? tf("subExpired", "Muddat tugagan") : `${days} ${dayLbl}`
  // o'lcham: matn batareyka ichiga sig'adi («365 дн» ham)
  const w = compact ? 52 : 60, h = compact ? 20 : 22
  return (
    <>
    <Tooltip title={sub.abonent
      ? `${tf("abTitle", "Абонентская плата")}: ${tf("abPaidUntilLc", "оплачено до")} ${until.format("DD.MM.YYYY")} — ${label}. ${tf("abBatteryHint", "Нажмите — подробности")}`
      : `${tf("subTermLbl", "Foydalanish muddati")}: ${until.format("DD.MM.YYYY")} — ${label}. ${tf("subExtendHint", "Uzaytirish: SAV administratori")}`}>
      <div className={`sub-battery ${blink}`} onClick={sub.abonent ? () => setOpen(true) : undefined} data-testid="sub-battery"
        style={{ display: "inline-flex", alignItems: "center", flexShrink: 0, whiteSpace: "nowrap", cursor: sub.abonent ? "pointer" : "default", paddingRight: 6 }}>
        <style>{`
          @keyframes subBlinkSlow { 0%, 100% { opacity: 1 } 50% { opacity: .25 } }
          @keyframes subBlinkFast { 0%, 100% { opacity: 1 } 50% { opacity: .15 } }
          .sub-blink-slow .sub-battery-fill { animation: subBlinkSlow 1.6s ease-in-out infinite }
          .sub-blink-fast .sub-battery-fill { animation: subBlinkFast .55s ease-in-out infinite }
        `}</style>
        <div style={{ position: "relative", width: w, height: h, border: `2px solid ${color}`, borderRadius: 5, boxSizing: "border-box", background: "rgba(255,255,255,.12)" }}>
          {/* batareyka «burni» */}
          <div style={{ position: "absolute", right: -6, top: (h - 10) / 2 - 2, width: 4, height: 10, background: color, borderRadius: "0 2px 2px 0" }} />
          {/* zaryad */}
          <div className="sub-battery-fill" style={{ position: "absolute", left: 1, top: 1, bottom: 1, width: `calc(${Math.max(pct, lastDay ? 0 : 3)}% - 2px)`, background: color, borderRadius: 3, transition: "width .4s" }} />
          {/* matn — batareyka ICHIDA, markazda */}
          <span style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: lastDay ? h - 6 : 11, lineHeight: 1, letterSpacing: 0.2, textShadow: "0 0 3px rgba(0,0,0,.75)", whiteSpace: "nowrap", userSelect: "none" }}>
            {lastDay ? "×" : `${days} ${dayLbl}`}
          </span>
        </div>
      </div>
    </Tooltip>
    {open ? <Suspense fallback={null}><AbonentMineModal onClose={() => setOpen(false)} /></Suspense> : null}
    </>
  )
}
